/**
 * Auth token local storage key
 */
export const STANDALONE_AUTH_TOKEN_KEY = 'auth-token';

/**
 * Refresh token local storage key.
 */
export const STANDALONE_REFRESH_TOKEN_KEY = 'refresh-token';

export const AUTH_SESSION_KEY = 'session';
